{
  "id": 5,
  "location": "cafe",
  "difficulty": "easy",
  "moves": 10,
  "kinds": 5,
  "goals": [
    { "type": "mud" },
    { "type": "collect", "kind": "latte", "count": 16 }
  ],
  "stars": [2420, 3750],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". x x x x x x .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.977, "movesLeft": 4.6, "closeLosses": 0.018, "target": 0.92 }
}
